import {
  createGlobalStyle,
  GlobalStyleComponent
} from 'styled-components';
import { connect } from 'react-redux';
import { device } from '../../theme';

const GlobalStyle: GlobalStyleComponent<any, any> = createGlobalStyle`
  @font-face {
    font-family: 'Prompt';
    src: url('/static/Fugue-Regular.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
        url('/static/Fugue-Regular.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
    font-style: normal;
    font-weight: 400;
  }
  
  html {
    display: flex;
    font-family: 'Prompt';
    font-size: 10px;
    color: ${props => props.theme.textPrimary};    
    max-height: 100vh;
    max-width: 100vw;
    height: 100vh;
    width: 100vw;
  }
  
  body {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: flex-start;
    background-color: ${props => props.theme.background};
    margin: 0;
    height: 100vh;
    width: 100vw;
  }
  
  button {
    display: flex;
    border-radius: 3px;
    margin: 0.3em;
    padding: 0.3em;
    background: transparent;
    color: ${(props) => props.theme.primary};
    border: 0.1em solid ${(props) => props.theme.primary};
    font-family: 'Prompt';
    font-size: 10px;
    text-align: center;
  }
  
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-height: 100vh;
    max-width: 100vw;
  }
  
  a {
    text-decoration: none;
  }
  
  p {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  @media ${device.mobileM} {
    p {
      font-size: 120%;
    }

    button {
      font-size: 120%;
    }
  }

  @media ${device.tablet} {
    p {
      font-size: 140%;
    }

    button {
      font-size: 140%;
    }
  }

  @media ${device.laptop} {
    p {
      font-size: 180%;
    }

    button {
      
    } 
  }

  @media ${device.desktop} {
    p {
      font-size: 180%;
    }

    button {
      
    }
  }
    
  @media (orientation: landscape) {
    body {
      
    }

    button {
      
    }
  }
`;


const mapStateToProps = (state: any) => {
  return {
    background: state.background,
    primary: state.primary
  };
};

export default connect(mapStateToProps)(GlobalStyle);
